export default __webpack_public_path__ + "static/media/hamrah_huree.e3a9feb9.jpg";